module.exports = __webpack_public_path__ + "img/conlaba1.63b4fb77.png";